@if ([formModes.View, formModes.Edit, formModes.Create].includes(formMode)) {
	<p-toolbar class="app-tabs-toolbar">
		<ng-template pTemplate="left" />
		<ng-template pTemplate="right">
			@if (showSendInvitation() && formMode == formModes.View) {
				<div pTooltip="Send Invitation" class="ml-toolbar">
					<p-button icon="pi pi-send" label="Send Invitation" (onClick)="sendInvitation()" />
				</div>
			}
			@if (showResetLogin() && formMode == formModes.View) {
				<div pTooltip="Reset Login" class="ml-toolbar">
					<p-button icon="pi pi-refresh" label="Reset Login" (onClick)="resetLogin()" data-testid="resetLoginExternalUserProfileDetailsButton" />
				</div>
			}
			@if (showEdit() && formMode == formModes.View) {
				<div class="ml-toolbar" [pTooltip]="getEditTooltip()">
					<p-button icon="pi pi-pencil" [disabled]="!allowEdit()" label="Edit" (onClick)="editDetails()" data-testid="externalUserProfileDetailsEditButton" />
				</div>
			}
			@if (formMode == formModes.Create) {
				<div class="ml-toolbar" pTooltip="Save External User Profile">
					<p-button icon="pi pi-save" label="Save" (onClick)="saveDetails()" />
				</div>
			}
			@if (formMode == formModes.Edit) {
				<div class="ml-toolbar" pTooltip="Save External User Profile" data-testid="externalUserProfileDetailsSave">
					<p-button icon="pi pi-save" label="Save" (onClick)="saveDetails()" />
				</div>
			}
			@if (formMode == formModes.Edit) {
				<div class="ml-toolbar" pTooltip="Cancel External User Profile">
					<p-button icon="pi pi-ban" label="Cancel" (onClick)="cancelDetailsEdit()" />
				</div>
			}
		</ng-template>
	</p-toolbar>
}
<form [formGroup]="detailForm">
	<div class="app-form-grid">
		<!-- row -->

		<app-form-item
			[visible]="[formModes.View, formModes.Edit].includes(formMode)"
			[controlType]="formControls.Textbox"
			[control]="detailForm.get('username')"
			label="Username" />
		<app-form-item
			[visible]="[formModes.View, formModes.Edit].includes(formMode)"
			[editable]="[formModes.Edit].includes(formMode)"
			[controlType]="formControls.Textbox"
			[control]="detailForm.get('displayName')"
			label="Display Name"
			autofocus />
		<app-form-item
			[visible]="[formModes.View, formModes.Edit].includes(formMode)"
			[editable]="[formModes.Edit].includes(formMode) && isCurrentUser == false"
			[controlType]="formControls.Autocomplete"
			[control]="detailForm.get('status')"
			[lookupValues]="statuses"
			label="Status" />
		<app-form-item
			[visible]="[formModes.View, formModes.Edit].includes(formMode)"
			[editable]="false"
			[controlType]="formControls.Textbox"
			[control]="detailForm.get('userRelationType')"
			label="Type"
			data-testid="externalUserProfileDetailsType" />

		<!-- row -->

		<app-form-item
			[visible]="[formModes.View, formModes.Edit].includes(formMode)"
			[editable]="[formModes.Edit].includes(formMode)"
			[controlType]="formControls.Textbox"
			[control]="detailForm.get('contactPhone')"
			label="Phone #" />
		<app-form-item
			[visible]="[formModes.View, formModes.Edit].includes(formMode)"
			[editable]="[formModes.Edit].includes(formMode)"
			[controlType]="formControls.Textbox"
			[control]="detailForm.get('contactMobile')"
			label="Mobile #" />
		<app-form-item
			[visible]="[formModes.View, formModes.Edit].includes(formMode)"
			[editable]="[formModes.Edit].includes(formMode)"
			[controlType]="formControls.Textbox"
			[control]="detailForm.get('contactEmail')"
			label="E-mail" />
		<app-form-item
			[visible]="[formModes.View, formModes.Edit].includes(formMode)"
			[editable]="[formModes.Edit].includes(formMode)"
			[controlType]="formControls.Textbox"
			[control]="detailForm.get('mobileNumber')"
			label="MFA Mobile #" />

		<!-- row -->

		@if (isClientUser) {
			<app-form-item
				[controlType]="formControls.Textbox"
				[control]="detailForm.get('clientName')"
				label="Client"
				[linkRecordTypeCode]="RecordTypeConstants.Client"
				[linkRecordId]="detailForm.get('clientId').value"
				linkTooltip="Click for Client Details"
				data-testid="externalUserProfileDetailsClient" />
			<app-form-item
				[visible]="[formModes.View, formModes.Edit].includes(formMode)"
				[editable]="[formModes.Edit].includes(formMode) && isCurrentUser == false"
				[controlType]="formControls.Autocomplete"
				[control]="detailForm.get('userRole')"
				[lookupValues]="userRoles"
				label="User Role"
				data-testid="externalUserProfileDetailsUserRoles" />
			<div class="app-form-element span-2"></div>
		}
		@if (isBusinessEntityUser) {
			<app-form-item
				[controlType]="formControls.Textbox"
				[control]="detailForm.get('businessEntityName')"
				label="Contractor"
				[linkRecordTypeCode]="RecordTypeConstants.Contractor"
				[linkRecordId]="detailForm.get('businessEntityId').value"
				linkTooltip="Click for Contractor Details"
				data-testid="externalUserProfileDetailsContractor" />
			<app-form-item
				[visible]="[formModes.View, formModes.Edit].includes(formMode)"
				[editable]="[formModes.Edit].includes(formMode) && isCurrentUser == false"
				[controlType]="formControls.Autocomplete"
				[control]="detailForm.get('userRole')"
				[lookupValues]="userRoles"
				label="User Role"
				data-testid="externalUserProfileDetailsUserRoles" />
			<div class="app-form-element span-2"></div>
		}
		@if (isCustomerUser) {
			<app-form-item
				[controlType]="formControls.Textbox"
				[control]="detailForm.get('clientName')"
				label="Client"
				[linkRecordTypeCode]="RecordTypeConstants.Client"
				[linkRecordId]="detailForm.get('clientId').value"
				linkTooltip="Click for Client Details"
				data-testid="externalUserProfileDetailsClient" />
			<app-form-item
				[visible]="[formModes.View, formModes.Edit].includes(formMode)"
				[editable]="[formModes.Edit].includes(formMode) && isCurrentUser == false"
				[controlType]="formControls.Autocomplete"
				[control]="detailForm.get('userRole')"
				[lookupValues]="userRoles"
				label="User Role"
				data-testid="externalUserProfileDetailsUserRoles" />
			<div class="app-form-element span-2"></div>
		}

		<!-- row -->

		@if (isBusinessEntityUser) {
			<app-form-item
				[visible]="[formModes.View, formModes.Edit].includes(formMode)"
				[controlType]="formControls.Textbox"
				[control]="detailForm.get('linkedBusinessEntityName')"
				label="Contractor Worker"
				[linkRecordTypeCode]="RecordTypeConstants.ContractorWorker"
				[linkRecordId]="detailForm.get('linkedBusinessEntityId').value"
				linkTooltip="Click for Worker Details"
				data-testid="externalUserProfileDetailsWorker" />
			<div class="app-form-element span-3"></div>
		}
		@if (isCustomerUser) {
			<app-form-item
				[visible]="[formModes.View, formModes.Edit].includes(formMode)"
				[editable]="[formModes.Edit].includes(formMode) && isCurrentUser == false"
				[controlType]="formControls.MultiSelect"
				[multiSelectCustomSearch]="workActivityLookupService.searchAssetLookupsForClientPaged"
				[enableLazyLoading]="true"
				[control]="detailForm.get('assets')"
				label="Properties or Assets"
				data-testid="externalUserProfileDetailsAssets"
				columns="4" />
		}

		<!-- row -->
		@if ([formModes.Edit, formModes.View].includes(formMode)) {
			<app-added-updated-details class="app-form-element span-4" [addedUpdatedDetails]="addedUpdatedDetails" />
		}
	</div>
</form>

<p-dialog
	header="Confirm Reset Login"
	[(visible)]="showResetLoginDialog"
	[modal]="true"
	[draggable]="false"
	[resizable]="false"
	class="w-md"
	(onHide)="cancelResetLogin()">
	<div>Please type in all-caps RESET and click OK to confirm.</div>
	<input
		pInputText
		type="text"
		class="mt-2 w-full"
		[value]="resetLoginConfirmationText"
		(input)="resetLoginConfirmationText = $any($event.target).value"
		data-testid="resetLoginExternalUserProfileDetailsTextInput" />
	<ng-template pTemplate="footer">
		<p-button label="Cancel" icon="pi pi-times" [text]="true" (onClick)="cancelResetLogin()" />
		<p-button
			label="OK"
			icon="pi pi-check"
			[disabled]="resetLoginConfirmationText?.trim() !== 'RESET'"
			(onClick)="confirmResetLogin()"
			data-testid="resetLoginExternalUserProfileDetailsConfirmButton" />
	</ng-template>
</p-dialog>
